<template>
  <va-modal
    :value="isOpen"
    id="a4aTestSessionDetailsModal"
    ref="a4aTestSessionDetailsModal"
    :showOkay="false"
    @cancel="onClose"
    :fixed-layout="true"
    :size="'large'"
    :hideDefaultActions="true">
    <div slot="header" class="modal-title d-flex justify-content-between mb-0">
      <span>{{ $t('audiology_4_all.titles.testSessionDetails') }}</span>
    </div>

    <div class="row">
      <label>{{$t('audiology_4_all.titles.columnTitles.createdAt')}}:</label>&ensp;
      <span>{{testSession.createdAt | localTime}}</span>
    </div>

    <div>
      <label> {{$t('audiology_4_all.titles.columnTitles.finishedSubtests')}}:</label>
      <ul>
        <li v-for="(item, index) in testSession.finishedSubtests">
          <!--{{ $t(`audiology_4_all.titles.tests.${item.subtest.slug}`)}}-->
          <div>
            <va-card>
              <div  v-if="item.slug !== 'tonalTestQuestionnaire'">
                <h6 class="is-bold mb-0">{{ $t(`audiology_4_all.titles.tests.${item.subtest.slug}`) }}</h6>
                <A4ASubtestTable
                  :subtest="item.subtest"
                  :account="account"
                  :testSessionId="testSession.sessionId"
                  class="mb-2">
                </A4ASubtestTable>
              </div>
            </va-card>
          </div>
        </li>
      </ul>

    </div>


  </va-modal>
</template>

<script>
import A4ATestCard from "@/components/clinical/accounts/AccountDetails/A4A/A4ATestCard.vue";
import A4ASubtestTable from "@/components/clinical/accounts/AccountDetails/A4A/A4ASubtestTable.vue";

export default {
  components: {A4ASubtestTable, A4ATestCard},
  props: {
    testSession: {
      type: Object,
      required: true,
      default: null
    },
    account: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    onClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss">
label {
  color: $vue-green;
  font-size: 15px;

}
.subtestTitle {
  color: $vue-green;
}
</style>
